import React, {Component} from 'react';
import './ActionPopUp.css';
import {connect} from 'react-redux';

import {AnimatedDialog} from '../../widgets';
import {uiActions} from '../../chrome';

class ActionPopUp extends Component {
	render() {
		const {onClose, actions} = this.props;

		return (
			<section className="actionPopUp">
				<button className="close-btn" onClick={onClose}>
					<span className="icon icon-close" />
				</button>
				<div className="actionPopUp-body">
					<ul>
						{actions &&
							actions
								.filter(actions => !!actions)
								.map(({key, icon, label, onSelect}) => (
									<li key={key} onClick={onSelect}>
										<div>
											{icon && <i className={`icon ${icon}`} />}
											<span className="OptionsButton-item-label"> {label}</span>
										</div>
									</li>
								))}
					</ul>
				</div>
			</section>
		);
	}
}

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ActionPopUp);



// WEBPACK FOOTER //
// ./src/mobile/bottom-nav-actions/ActionPopUp.js